import StarIcon from '@mui/icons-material/Star';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, ButtonProps } from 'shared/mui/Buttons';

export type FilterFavouriteButtonProps = ButtonProps;

export const FilterSaveFavoriteButton: React.FC<FilterFavouriteButtonProps> = ({
  label,
  color = 'primary',
  variant = 'outlined',
  ...restProps
}) => {
  const translate = useTypedTranslate();

  return (
    <Button
      color={color}
      label={label || translate('app.buttons.saveFilter')}
      startIcon={<StarIcon />}
      variant={variant}
      {...restProps}
    />
  );
};
